/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';

import { API_URL } from '../../constants/api';
import KaafiPayWeb from './KaafiPay/KaafiPay';
import GalmudugWeb from './galmudug/Galmudug';

const WebRenderer = () => {
  if (API_URL.includes('galmudug') || API_URL.includes('hirshabeele')) {
    return <GalmudugWeb />;
  } else {
    return <KaafiPayWeb />;
  }
};

export default WebRenderer;
